import React from 'react';
import { Controller, get, useFormContext } from 'react-hook-form';
import InputPasswd from './InputPasswd';

const ControlledInputPassword = ({ label, name, rules, placeholder, show = false, classContainer, classInput, showTips, handleTipsPassword }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = get(errors, name);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules && rules}
      render={({ field: { onChange, value } }) => {
        return (
          <InputPasswd
            classContainer={classContainer}
            label={label}
            value={value}
            name={name}
            inputCb={onChange}
            placeholder={placeholder}
            show={show}
            error={error}
            classInput={classInput}
            showTips={showTips}
            handleTipsPassword={handleTipsPassword}
          />
        );
      }}
    />
  );
};

export default ControlledInputPassword;
